import prestashop from 'prestashop';

export class ShowroomRequest {
    init() {
        const _this = this;
        $(document.body).on('submit', '.js-showroomform', function (e) {
            e.preventDefault();
            _this.submitShowroomForm();
        });
    }

    submitShowroomForm() {
        $.post({
            url: prestashop.modules.veshowroom.ajaxShowroomUrl,
            dataType: 'json',
            data: {
                'veshowroomnom': $('input[name="veshowroomnom"]').val(),
                'veshowroomtelephone': $('input[name="veshowroomtelephone"]').val(),
                'veshowroomcodepostal': $('input[name="veshowroomcodepostal"]').val(),
                'veshowroomrefproduit': $('input[name="veshowroomrefproduit"]').val()
            },
            success: response => {
                if (response.success) {
                    $('.js-showroomform').after('<div class="alert alert-success mt-1">Votre demande a bien été soumise.</div>')
                }
                else {
                    $('.js-showroomform').after('<div class="alert alert-danger mt-1">Un problème est survenu.</div>')
                }
            },
            error: response => {
                console.error(response);
                $('.js-showroomform').after('<div class="alert alert-danger mt-1">Un problème est survenu.</div>')
            }
        })
    }
}